import { BaseGraphQL } from "~/services/baseGraphQL";
import { GRAPHQL_AUTHENTICATION } from "~/constants/url";
import { JsonResponseType } from "~/types/jsonResponseType";
import { AuthenticationInput, LoginResponse } from "../../../types/login";

const authenticationGraph = BaseGraphQL({
  baseUrl: GRAPHQL_AUTHENTICATION,
});

export const loginWithCredentials = async (input: AuthenticationInput) => {
  const query = `
     query ($username: String!, $password: String!, $captchaResponse: String) {
      authenticate {
        authenticateFirst(
          authenticationVM: {
            userName: $username
            password: $password
            captchaResponse: $captchaResponse
          }
        ) {
          messageCode
          succeed
          data {
            userCompaniesInfo {
              companyId
              companyLogoURL
              companyType
              companyName
              isDemo
              tokenObject {
                token
                userName
              }
              userId
            }
            userName
          }
        }
      }
    }
  `;

  return await authenticationGraph<
    LoginResponse,
    {
      authenticate: { authenticateFirst: JsonResponseType<LoginResponse> };
    }
  >(
    {
      action: "UserGraphQL",
      query,
      variables: { ...input },
    },
    (input) => input.authenticate.authenticateFirst,
  );
};
